<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <div v-if="data.length > 0">
        <b-table class="border-top-0 mb-0" :items="data" :fields="fields" striped>
          <template v-slot:cell(createdAt)="data">{{ data.value | moment("MMMM Do YYYY") }}</template>
          <template v-slot:cell(action)="row">
            <b-button size="sm" variant="danger" v-b-modal="String(row.item.id)">Delete</b-button>
            <b-modal
              :id="String(row.item.id)"
              title="Delete Card"
              @ok="() => deleteCard(row.item.id)"
            >
              <p class="my-4">Confirmation</p>
            </b-modal>
          </template>
        </b-table>
      </div>
      <div class="text-center m-3" v-else>
        <h5 class="card-title">Search Result</h5>
        <p class="card-text">No Data</p>
      </div>
    </div>
  </div>
</template>

<script>
import GetUserCards from "../../../../store/actions/getUserCards";
import DeleteCard from "../../../../store/actions/deleteUserCard";
import ShowError from "../../../../helpers/showError";
import ContentLoader from "../../../../components/ContentLoader";

export default {
  name: "UserCards",
  components: {
    loader: ContentLoader
  },
  data() {
    return {
      loading: false,
      data: [],
      fields: [
        "id",
        "name",
        "lastFourDigits",
        "cardBankName",
        "binNumber",
        "association",
        "createdAt",
        "action"
      ]
    };
  },
  created() {
    this.getCards();
  },
  methods: {
    async getCards() {
      try {
        this.loading = true;
        this.data = await GetUserCards(this.$route.params.id);
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    },
    async deleteCard(id) {
      try {
        this.loading = true;
        await DeleteCard(id);
        this.getCards();
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
